<template>
  <label :for="id" class="radio">
    <input
      type="radio"
      :id="id"
      :name="name"
      :checked="checked"
      :disabled="disabled"
      @change="e => $emit('change', e, options)"
    >
    <span class="round">
      <span class="round_in"></span>
    </span>
    <span class="text">{{ text }}</span>
  </label>
</template>

<script>
export default {
  name: "custom-radio",
  props: {
    id: String,
    text: String,
    name: String,
    options: Object,
    checked: Boolean,
    disabled: Boolean,
  }
}
</script>

<style scoped lang="scss">
  .radio {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  input {
    position: absolute;
    z-index: -1;
    opacity: 0;
    &:checked + .round {
      border: 1px solid #B9765B;
      .round_in {
        width: 8px;
        height: 8px;
        background-color: #B9765B;
        border-radius: 50%;
      }
    }
  }

  .round {
    width: 16px;
    height: 16px;

    border-radius: 50%;
    border: 1px solid #808080;

    margin-right: 10px;

    display: flex;
    align-items: center;
    justify-content: center;
  }

  .text {
    font-family: "Open Sans", sans-serif;
    font-size: 16px;
    line-height: 1.5;
    color: #383838;
  }
</style>
